import { type RoleTypeEnum } from '../enums/RoleTypeEnum'

export interface UserRoleConstructor {
  id: number
  name: string
  type: RoleTypeEnum
}

export class UserRole {
  id: number
  name: string
  type: RoleTypeEnum

  constructor(data: UserRoleConstructor) {
    this.id = data.id
    this.name = data.name
    this.type = data.type
  }

  // Superusers are excluded from the report-access user picker (client-side;
  // API has no server-side exclusion param). Name check matches Angular parity —
  // RoleTypes has no SUPERUSER member.
  get isSuperuser(): boolean {
    return this.name === 'Superuser'
  }
}
